export default "__VITE_ASSET__CAYLaDdY__"